// extracted by mini-css-extract-plugin
export default {"inputRoot":"booking_note_input-module___inputRoot___cbf47b08"};